import { gql } from 'react-apollo';

export default gql`
  mutation cancelInvestment($investmentId: ID!) {
    cancelInvestment(investmentId: $investmentId) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/cancelInvestment.js